import React from 'react';

const CategoryList = ({ categories }) => {
  if (!Array.isArray(categories) || categories.length === 0) {
    return <p className="empty-hint">Категорий пока нет</p>;
  }

  return (
    <div className="categories-list">
      {Array.isArray(categories) && categories.map(cat => (
        <div key={cat.id} className="category-item">
          <div className="category-info">
            <span className="category-name">{cat.name}</span>
            <span className="category-desc">{cat.description}</span>
          </div>
        </div>
      ))}
    </div>
  );
};

export default CategoryList;
